import React from 'react';
import SidebarItem from './Common/SidebarItem';
import Item from '../Data/SideBar.json';
import GrowUpImg from './Images/growUp.png';

const SideBar = (props) => {
    const { isShow, setIsShow } = props;

    return (
        <div className={`relative ${isShow ? "left-0 ease-in z-40 w-3/4  md:w-[21rem]" : "-left-72 w-0 ease-out"} [box-shadow:4px_2px_50px_20px_#6b7280]  h-screen overflow-y-auto bg-gray-800 transition-all duration-300 md:shadow-none`}>
            <div className="py-2 px-4 h-14 flex justify-between md:gap-2 md:justify-center items-center bg-cyan-500">
                <div className='flex justify-center items-center gap-1'>
                    <img src={GrowUpImg} alt="GrowUp" className='object-cover w-16' />
                    <h4 className='font-lato font-medium text-sm xsm:text-base xsm:font-bold'>Grow Up Fitness Club</h4>
                </div>
                <span className='cursor-pointer block  xsm:text-xl text-gray-700 md:hidden opacity-60' onClick={() => setIsShow(false)}>
                    <i className="fa-solid fa-xmark "></i>
                </span>
            </div>
            {Item.map((item, index) => {
                return <SidebarItem key={index} item={item} />
            })}
        </div>
    )
}

export default SideBar;